var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"nav-buttons text-company-link"},_vm._l((_vm.links),function(link){return _c('a',{key:link.label,staticClass:"inline-block px-lg mb-xs",attrs:{"href":link.url}},[_vm._v("\n        "+_vm._s(link.title)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }